import React, { Component } from 'react';
import Nav from 'react-bootstrap/Nav';
import NavItem from 'react-bootstrap/NavItem';
import NavLink from 'react-bootstrap/NavLink';
import Tab from 'react-bootstrap/Tab';
import withSounds from 'containers/withSounds';
import GenericDropdown from 'components/GenericDropdown';
import './TabView.css';

const NavItemWithSounds = withSounds({ mouseEnterSound: true })(NavItem);

class TabView extends Component {
  state = {
    selectedTab: undefined
  };

  handleSelect = selectedTab => {
    this.setState({ selectedTab });
    this.props.onSelectTab && this.props.onSelectTab(selectedTab);
  };

  renderNavItem = (tabTitle, activeTabKey) => {
    const Comp = tabTitle.key === activeTabKey ? NavItem : NavItemWithSounds;
    return (
      <Comp key={tabTitle.key} className={`tab ${tabTitle.key}-tab`}>
        <NavLink eventKey={tabTitle.key}>{tabTitle.title}</NavLink>
      </Comp>
    );
  };

  renderDropdownOption = (tab, activeTabKey) => (
    <div
      key={tab.key}
      className={`${tab.key === activeTabKey ? 'selected-option' : ''}`}
      role="button"
      onClick={() => this.handleSelect(tab.key)}
    >
      {tab.title}
    </div>
  );

  renderTabElements = activeTabKey => {
    const { tabTitles, navClassName, dropdownClassName, id } = this.props;
    const isDesktopOrLarger = this.props.matchesBreakpoint;
    const tabTitleElements = tabTitles.map(tabTitle =>
      this.renderNavItem(tabTitle, activeTabKey)
    );
    const options = tabTitles.map(tab =>
      this.renderDropdownOption(tab, activeTabKey)
    );
    const activeTab = tabTitles.find(tab => tab.key === activeTabKey);

    if (!isDesktopOrLarger) {
      // Render Dropdown for smaller screens
      return (
        <GenericDropdown
          className={dropdownClassName}
          dropdownId={`${id}-dropdown`}
          format="transparent"
          title={activeTab ? activeTab.title : 'Select'}
          withHover={false}
          withCaret
        >
          {options}
        </GenericDropdown>
      );
    } else {
      // Render Nav Tabs for desktop or larger screens
      return (
        <Nav variant="tabs" className={`${navClassName || ''}`}>
          {tabTitleElements}
        </Nav>
      );
    }
  };

  render() {
    const { selectedTab } = this.state;
    const {
      selectedTab: overrideTab,
      defaultTab,
      tabTitles,
      className,
      id,
      children,
      matchesBreakpoint
    } = this.props;

    const isDesktopOrLarger = matchesBreakpoint;
    const tabCount = (tabTitles && tabTitles.length) || 0;
    const activeTabKey =
      overrideTab !== undefined
        ? overrideTab
        : selectedTab !== undefined
        ? selectedTab
        : defaultTab !== undefined
        ? defaultTab
        : tabCount && tabTitles[0].key;
    const activeTabIndex =
      tabCount &&
      tabTitles.findIndex(tabTitle => tabTitle.key === activeTabKey);

    return (
      <div
        className={`tab-view tab-view-${tabCount} ${activeTabKey}-active ${
          className || ''
        }`}
      >
        <div className="tab-view-container">
          <Tab.Container
            id={`${id}-tabs`}
            activeKey={activeTabKey}
            onSelect={this.handleSelect}
          >
            <div className={`tab-view-nav ${activeTabKey}-active`}>
              {this.renderTabElements(activeTabKey)}
              {isDesktopOrLarger && (
                <div className={`tab-indicator tab-${activeTabIndex}`} />
              )}
            </div>
            {children}
          </Tab.Container>
        </div>
      </div>
    );
  }
}

export default TabView;
